import _ec from "elliptic";
var EC = _ec.ec;
var ED = _ec.eddsa;
export { EC, ED };
//# sourceMappingURL=elliptic.js.map